import { CognitoUserSession } from "amazon-cognito-identity-js";

export enum ModalActionTypes {
   OPEN_SIGN_UP = 'AUTH/OPEN_SIGN_UP',
   OPEN_LOGIN = 'AUTH/OPEN_LOGIN',
   OPEN_CHOOSER = 'AUTH/OPEN_CHOOSER',
   CLOSE_MODAL = 'AUTH/CLOSE_MODAL',
   OPEN_PASSWORD_SET = 'AUTH/OPEN_PASSWORD_SET',
   OPEN_CODE = '/AUTH/OPEN_CODE',
   OPEN_NAME_SURNAME = 'AUTH/OPEN_NAME_SURNAME',
   OPEN_PASSWORD_LOGIN = 'AUTH/OPEN_PASSWORD_LOGIN',
   OPEN_FORGOT_PASSWORD = 'AUTH/OPEN_FORGOT_PASSWORD',
}

export interface OpenSignUpAction {
   type: ModalActionTypes.OPEN_SIGN_UP,
}

export interface OpenChooserAction {
   type: ModalActionTypes.OPEN_CHOOSER,
}

export interface OpenLoginAction {
   type: ModalActionTypes.OPEN_LOGIN,
}

export interface OpenNameSurname {
   type: ModalActionTypes.OPEN_NAME_SURNAME,
}

export interface OpenPasswordSet {
   type: ModalActionTypes.OPEN_PASSWORD_SET,
}

export interface OpenCode {
   type: ModalActionTypes.OPEN_CODE,
}

export interface CloseModalAction {
   type: ModalActionTypes.CLOSE_MODAL,
}

export interface OpenPasswordLogin {
   type: ModalActionTypes.OPEN_PASSWORD_LOGIN,
}

export interface OpenForgotPassword {
   type: ModalActionTypes.OPEN_FORGOT_PASSWORD,
}

export type ModalAction =
   | OpenLoginAction
   | OpenSignUpAction
   | OpenChooserAction
   | OpenNameSurname
   | OpenPasswordSet
   | OpenCode
   | OpenPasswordLogin
   | OpenForgotPassword
   | CloseModalAction

export const openSignUpAction = (): OpenSignUpAction => ({
   type: ModalActionTypes.OPEN_SIGN_UP,
});

export const openLoginAction = (): OpenLoginAction => ({
   type: ModalActionTypes.OPEN_LOGIN,
});

export const openChooserAction = (): OpenChooserAction => ({
   type: ModalActionTypes.OPEN_CHOOSER,
});

export const closeModalAction = (): CloseModalAction => ({
   type: ModalActionTypes.CLOSE_MODAL,
});

export const openPasswordSet = (): OpenPasswordSet => ({
   type: ModalActionTypes.OPEN_PASSWORD_SET,
})

export const openCode = (): OpenCode => ({
   type: ModalActionTypes.OPEN_CODE,
})

export const openNameSurname = (): OpenNameSurname => ({
   type: ModalActionTypes.OPEN_NAME_SURNAME,
})

export const openPasswordLogin = (): OpenPasswordLogin => ({
   type: ModalActionTypes.OPEN_PASSWORD_LOGIN,
})

export const openForgotPassword = (): OpenForgotPassword => ({
   type: ModalActionTypes.OPEN_FORGOT_PASSWORD,
})

export enum LoginActionTypes {
   EMAIL_CHANGED = 'AUTH/EMAIL_CHANGED',
   PASSWORD_CHANGED = 'AUTH/PASSWORD_CHANGED',
   CODE_CHANGED = 'AUTH/CODE_CHANGED',
   NEW_PASSWORD_CHANGED = 'AUTH/NEW_PASSWORD_CHANGED',
   TIMER_TICK = 'AUTH/TIMER_TICK',

   SIGNUP_REQUEST = 'AUTH/SIGNUP_REQUEST',
   SIGNUP_SUCCESS = 'AUTH/SIGNUP_SUCCESS',
   SIGNUP_FAILED = 'AUTH/SIGNUP_FAILED',

   CONFIRM_CODE_REQUEST = 'AUTH/CONFIRM_CODE_REQUEST',
   CONFIRM_CODE_SUCCESS = 'AUTH/CONFIRM_CODE_SUCCESS',
   CONFIRM_CODE_FAILED = 'AUTH/CONFIRM_CODE_FAILED',

   SAVE_USER_DATA = 'AUTH/SAVE_USER_DATA',

   SIGNIN_REQUEST = 'AUTH/SIGNIN_REQUEST',
   SIGNIN_SUCCESS = 'AUTH/SIGNIN_SUCCESS',
   SIGNIN_FAILED = 'AUTH/SIGNIN_FAILED',

   FORGOT_PASSWORD_REQUEST = 'AUTH/FORGOT_PASSWORD_REQUEST',
   FORGOT_PASSWORD_SUCCESS = 'AUTH/FORGOT_PASSWORD_SUCCESS',
   FORGOT_PASSWORD_FAILED = 'AUTH/FORGOT_PASSWORD_FAILED',

   CONFIRM_PASSWORD_REQUEST = 'AUTH/CONFIRM_PASSWORD_REQUEST',
   CONFIRM_PASSWORD_SUCCESS = 'AUTH/CONFIRM_PASSWORD_SUCCESS',
   CONFIRM_PASSWORD_FAILED = 'AUTH/CONFIRM_PASSWORD_FAILED',

   SIGN_OUT_REQUEST = 'AUTH/SIGN_PUT_REQUEST',
   SIGN_OUT_SUCCESS = 'AUTH/SIGN_OUT_SUCCESS',
   SIGN_OUT_FAILED = 'AUTH/SIGN_OUT_FAILED',

   GET_SESSION = 'AUTH/GET_SESSION',
   GET_SESSION_SUCCESS = 'AUTH/GET_SESSION_SUCCESS',
   GET_SESSION_FAILED = 'AUTH/GET_SESSION_FAILED',
}

export interface EmailChangedAction {
   type: LoginActionTypes.EMAIL_CHANGED,
   payload: { email: string },
}

export interface TimerTickAction {
   type: LoginActionTypes.TIMER_TICK,
}

export interface PasswordChangedAction {
   type: LoginActionTypes.PASSWORD_CHANGED,
   payload: { password: string },
}

export interface SignUpRequest {
   type: LoginActionTypes.SIGNUP_REQUEST;
   payload: { email: string, password: string };
}

export interface SignUpSuccess {
   type: LoginActionTypes.SIGNUP_SUCCESS;
   result: any;
}

export interface SignUpFailed {
   type: LoginActionTypes.SIGNUP_FAILED;
   error: string;
}

export interface ConfirmCodeRequest {
   type: LoginActionTypes.CONFIRM_CODE_REQUEST;
   payload: { email: string, code: string };
}

export interface ConfirmCodeSuccess {
   type: LoginActionTypes.CONFIRM_CODE_SUCCESS;
   result: any;
}

export interface ConfirmCodeFailed {
   type: LoginActionTypes.CONFIRM_CODE_FAILED;
   error: string;
}

export interface SaveUserData {
   type: LoginActionTypes.SAVE_USER_DATA;
   payload: { name: string, surname: string };
}
export interface SignInRequest {
   type: LoginActionTypes.SIGNIN_REQUEST,
   payload: { email: string, password: string },
}
export interface SignInSuccess {
   type: LoginActionTypes.SIGNIN_SUCCESS,
   result: any,
}
export interface SignInFailed {
   type: LoginActionTypes.SIGNIN_FAILED,
   error: string,
}

export interface CodeChangedAction {
   type: LoginActionTypes.CODE_CHANGED,
   payload: { code: string },
}

export interface NewPasswordChangedAction {
   type: LoginActionTypes.NEW_PASSWORD_CHANGED,
   payload: { newPassword: string },
}

export interface ForgotPasswordRequest {
   type: LoginActionTypes.FORGOT_PASSWORD_REQUEST,
   payload: { email: string },
}

export interface ForgotPasswordSuccess {
   type: LoginActionTypes.FORGOT_PASSWORD_SUCCESS,
   result: any,
}

export interface ForgotPasswordFailed {
   type: LoginActionTypes.FORGOT_PASSWORD_FAILED,
   error: string,
}

export interface ConfirmPasswordRequest {
   type: LoginActionTypes.CONFIRM_PASSWORD_REQUEST,
   payload: { email: string, code: string, newPassword: string }
}

export interface ConfirmPasswordSuccess {
   type: LoginActionTypes.CONFIRM_PASSWORD_SUCCESS,
   result: any,
}

export interface ConfirmPasswordFailed {
   type: LoginActionTypes.CONFIRM_PASSWORD_FAILED,
   error: string,
}

export interface SignOutRequest {
   type: LoginActionTypes.SIGN_OUT_REQUEST,
}

export interface SignOutSuccess {
   type: LoginActionTypes.SIGN_OUT_SUCCESS,
}

export interface SignOutFailed {
   type: LoginActionTypes.SIGN_OUT_FAILED,
   error: string,
}

export interface GetSessionAction {
   type: LoginActionTypes.GET_SESSION,
}

export interface GetSessionSuccess {
   type: LoginActionTypes.GET_SESSION_SUCCESS,
   payload: { email: string, session: CognitoUserSession },
}

export interface GetSessionFailed {
   type: LoginActionTypes.GET_SESSION_FAILED,
   error: Error,
}

export type LoginAction =
   | EmailChangedAction
   | PasswordChangedAction
   | TimerTickAction
   | SignUpRequest
   | SignUpSuccess
   | SignUpFailed
   | ConfirmCodeRequest
   | ConfirmCodeSuccess
   | ConfirmCodeFailed
   | SaveUserData
   | SignInRequest
   | SignInSuccess
   | SignInFailed
   | CodeChangedAction
   | NewPasswordChangedAction
   | ForgotPasswordRequest
   | ForgotPasswordSuccess
   | ForgotPasswordFailed
   | ConfirmPasswordRequest
   | ConfirmPasswordSuccess
   | ConfirmPasswordFailed
   | SignOutRequest
   | SignOutSuccess
   | SignOutFailed
   | GetSessionAction
   | GetSessionSuccess
   | GetSessionFailed

export const emailChangedAction = (email: string): EmailChangedAction => ({
   type: LoginActionTypes.EMAIL_CHANGED,
   payload: { email },
});

export const timerTickAction = (): TimerTickAction => ({
   type: LoginActionTypes.TIMER_TICK,
})

export const passwordChangedAction = (password: string): PasswordChangedAction => ({
   type: LoginActionTypes.PASSWORD_CHANGED,
   payload: { password },
})

export const signUpRequest = (email: string, password: string): SignUpRequest => ({
   type: LoginActionTypes.SIGNUP_REQUEST,
   payload: { email, password },
});

export const signUpSucceeded = (result: any): SignUpSuccess => ({
   type: LoginActionTypes.SIGNUP_SUCCESS,
   result,
});

export const signUpFailed = (error: string): SignUpFailed => ({
   type: LoginActionTypes.SIGNUP_FAILED,
   error,
});

export const confirmCodeRequest = (email: string, code: string): ConfirmCodeRequest => ({
   type: LoginActionTypes.CONFIRM_CODE_REQUEST,
   payload: { email, code },
});

export const confirmCodeSucceeded = (result: any): ConfirmCodeSuccess => ({
   type: LoginActionTypes.CONFIRM_CODE_SUCCESS,
   result,
});

export const confirmCodeFailed = (error: string): ConfirmCodeFailed => ({
   type: LoginActionTypes.CONFIRM_CODE_FAILED,
   error,
});

export const saveUserData = (name: string, surname: string): SaveUserData => ({
   type: LoginActionTypes.SAVE_USER_DATA,
   payload: { name, surname },
});

export const signInRequest = (email: string, password: string): SignInRequest => ({
   type: LoginActionTypes.SIGNIN_REQUEST,
   payload: { email, password },
})

export const signInSucceeded = (result: any): SignInSuccess => ({
   type: LoginActionTypes.SIGNIN_SUCCESS,
   result,
})

export const signInFailed = (error: string): SignInFailed => ({
   type: LoginActionTypes.SIGNIN_FAILED,
   error,
})

export const codeChangedAction = (code: string): CodeChangedAction => ({
   type: LoginActionTypes.CODE_CHANGED,
   payload: { code },
})

export const newPasswordChangedAction = (newPassword: string): NewPasswordChangedAction => ({
   type: LoginActionTypes.NEW_PASSWORD_CHANGED,
   payload: { newPassword },
})

export const forgotPasswordRequest = (email: string): ForgotPasswordRequest => ({
   type: LoginActionTypes.FORGOT_PASSWORD_REQUEST,
   payload: { email }
})

export const forgotPasswordSucceeded = (result: any): ForgotPasswordSuccess => ({
   type: LoginActionTypes.FORGOT_PASSWORD_SUCCESS,
   result,
})

export const forgotPasswordFailed = (error: string): ForgotPasswordFailed => ({
   type: LoginActionTypes.FORGOT_PASSWORD_FAILED,
   error,
})

export const confirmPasswordRequest = (email: string, code: string, newPassword: string): ConfirmPasswordRequest => ({
   type: LoginActionTypes.CONFIRM_PASSWORD_REQUEST,
   payload: { email, code, newPassword },
})

export const confirmPasswordSucceeded = (result: any): ConfirmPasswordSuccess => ({
   type: LoginActionTypes.CONFIRM_PASSWORD_SUCCESS,
   result,
})

export const confirmPasswordFailed = (error: string): ConfirmPasswordFailed => ({
   type: LoginActionTypes.CONFIRM_PASSWORD_FAILED,
   error,
})

export const signOutRequest = (): SignOutRequest => ({
   type: LoginActionTypes.SIGN_OUT_REQUEST,
})

export const signOutSucceeded = (): SignOutSuccess => ({
   type: LoginActionTypes.SIGN_OUT_SUCCESS,
})

export const signOutFailed = (error: string): SignOutFailed => ({
   type: LoginActionTypes.SIGN_OUT_FAILED,
   error,
})

export const getSessionAction = (): GetSessionAction => ({
   type: LoginActionTypes.GET_SESSION,
})

export const getSessionSucceeded = (email: string, session: CognitoUserSession): GetSessionSuccess => ({
   type: LoginActionTypes.GET_SESSION_SUCCESS,
   payload: { email, session },
})

export const getSessionFailed = (error: Error): GetSessionFailed=>({
   type: LoginActionTypes.GET_SESSION_FAILED,
   error,
})

export type AuthAction = LoginAction | ModalAction;